import React  from 'react';
import { Route, Redirect } from 'react-router-dom';
import { logged } from './helpers';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            logged() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: '/ingresar',
                        state: { from: props.location }
                    }}
                />
            )
        }
    ></Route>
);

export default PrivateRoute;